<script>
    export let headline;
    export let subheadline;
    export let icon;
</script>
<div>
    <h2>{icon}</h2>
    <h3>{headline}</h3>
    <p>{subheadline}</p>
</div>

<style>
    div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        max-width: 450px;
    }

    h2 {
        font-size: 40px;
        margin: 0;
        padding: 0;
    }

    h3 {
        text-align: center;
        font-family: var(--font-body);
    }

    p {
        text-align: center;
    }

    @media (max-width: 768px) {
        div {
            gap: 0;
        }

        p {
            font-size: 16px;
            letter-spacing: 0px;
        }
    }
</style>